import React from "react";

import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";

import RbButtonAction from "components/RbButtonAction";
import RbHeader from "components/RbHeader/RbHeader";

function UsersHeader() {
  const history = useHistory();

  return (
    <RbHeader
      onBack={() => history.push("/main")}
      title="Users with a larger text to not break in two lines"
      subtitle="More information about the page"
      actions={
        <>
          <RbButtonAction Icon={AddIcon}>New</RbButtonAction>
          <RbButtonAction Icon={SearchIcon}>Search</RbButtonAction>
        </>
      }
    />
  );
}

UsersHeader.propTypes = {};

UsersHeader.defaultProps = {};

export default React.memo(UsersHeader);
